import { BrandDetailDocument } from "@tiicker/util/lib/contentful/types";
import TiiDisplay from "components/TiiDisplay/TiiDisplay";
import { Entry } from "contentful";
import Link from "next/link";
import { useRouter } from "next/router";
import styles from "./BrandTile.module.scss";

interface Props {
  brand?: Entry<BrandDetailDocument>;
  backgroundImageUrl?: string;
}

const BrandTile = (props: Props) => {
  const { brand, backgroundImageUrl } = props;
  const router = useRouter();

  if (!brand) {
    return <div className={styles.BrandTile}></div>;
  }

  return (
    <Link href="/brand/[symbol]" as={`/brand/${brand.fields.tickerSymbol}`}>
      <a className={styles.BrandTile}>
        <div className={styles.BrandTile__imageContainer}>
          <div className={styles.BrandTile__imageTint}></div>
          {backgroundImageUrl && (
            <img
              className={styles.BrandTile__backgroundImage}
              src={backgroundImageUrl}
            />
          )}
        </div>
        <div className={styles.BrandTile__brandText}>
          <TiiDisplay size="xs" text={brand.fields.tickerSymbol} />
          <h3 className={styles.BrandTile__brandHeading}>
            {brand.fields.brandName}
          </h3>
        </div>
      </a>
    </Link>

  );
};

export default BrandTile;
